import React from "react";
import { Navigate } from "react-router-dom";

// Authentication
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import VerifyRegistration from "../pages/Authentication/VerifyRegistration";
import RegisterWorkspace from "../pages/Authentication/RegisterWorkspace";
import ForgetPassword from "../pages/Authentication/ForgetPassword";
import AcceptInvitation from "../pages/Authentication/AcceptInvitation";

// Páginas públicas
import Home from "../pages/Home";
import VerificarExport from "../pages/Inspeccion/Verificar";
import PortalLogin from "../pages/Inspeccion/PortalLogin";
import PortalDashboard from "../pages/Inspeccion/PortalDashboard";
import PortalEmpleados from "../pages/Inspeccion/PortalEmpleados";
import PortalJornadas from "../pages/Inspeccion/PortalJornadas";
import PortalAuditoria from "../pages/Inspeccion/PortalAuditoria";
import PortalVerificar from "../pages/Inspeccion/PortalVerificar";

// Páginas Kronaly DS v1.1 — bundle Kronaly Web App.html
import Dashboard from "../pages/Dashboard";
import Jornada from "../pages/Jornada";
import HistorialJornadas from "../pages/Jornada/Historial";
import AuditoriaJornadas from "../pages/Jornada/Auditoria";
import Ausencias from "../pages/Ausencias";
import Solicitudes from "../pages/Solicitudes";
import Calendario from "../pages/Calendario";
import Empleados from "../pages/Empleados";
import RRHHJornadas from "../pages/RRHH/Jornadas";
import Equipos from "../pages/Equipos";
import Contratos from "../pages/Contratos";
import Horarios from "../pages/Horarios";
import Festivos from "../pages/Festivos";
import Documentos from "../pages/Documentos";
import MisDocumentos from "../pages/MisDocumentos";
import DocumentacionInterna from "../pages/DocumentacionInterna";
import DocumentacionInternaConfiguracion from "../pages/DocumentacionInterna/Configuracion";
import Reportes from "../pages/Reportes";
import Formacion from "../pages/Formacion";
import FormacionHistorial from "../pages/Formacion/Historial";
import FormacionCrear from "../pages/Formacion/Crear";
import FormacionCurso from "../pages/Formacion/Curso";
import SoporteDashboard from "../pages/SoporteIT";
import SoporteTickets from "../pages/SoporteIT/Tickets";
import SoporteCrear from "../pages/SoporteIT/Crear";
import SoporteTicketDetalle from "../pages/SoporteIT/TicketDetalle";
import SoporteInventario from "../pages/SoporteIT/Inventario";
import SoporteActivo from "../pages/SoporteIT/Activo";
import SoporteRecursos from "../pages/SoporteIT/Recursos";
import SoporteUsuario from "../pages/SoporteIT/Usuario";
import SoporteConocimiento from "../pages/SoporteIT/Conocimiento";
import SoporteReportes from "../pages/SoporteIT/Reportes";
import Configuracion from "../pages/Configuracion";
import Modulos from "../pages/Ajustes/Modulos";
import Accesos from "../pages/Ajustes/Accesos";
import InspeccionTokens from "../pages/Ajustes/InspeccionTokens";
import PreferenciasNotificaciones from "../pages/Ajustes/Notificaciones";
import Roles from "../pages/Roles";
import Estados from "../pages/Estados";
import ExcesosJornada from "../pages/ExcesosJornada";

function RedirectWithParams({ to }) {
  const id = window.location.pathname.split("/").pop();
  const target = to.replace(":employeeProfileId", id);
  return <Navigate to={target} replace />;
}

const authProtectedRoutes = [
  // Mi cuenta
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/jornada", component: <Jornada /> },
  { path: "/jornada/historial", component: <HistorialJornadas /> },
  { path: "/jornada/auditoria", component: <AuditoriaJornadas /> },
  { path: "/ausencias", component: <Ausencias /> },
  { path: "/mis-solicitudes", component: <Solicitudes mode="mine" /> },
  { path: "/documentos", component: <Documentos /> },
  { path: "/mis-documentos", component: <MisDocumentos /> },
  { path: "/documentacion-interna", component: <DocumentacionInterna /> },
  { path: "/documentacion-interna/configuracion", component: <DocumentacionInternaConfiguracion /> },

  // RRHH
  { path: "/solicitudes", component: <Solicitudes mode="inbox" /> },
  { path: "/calendario", component: <Calendario /> },
  { path: "/empleados", component: <Empleados /> },
  { path: "/empleados/:employeeProfileId", component: <Empleados /> },
  { path: "/equipos", component: <Equipos /> },
  { path: "/contratos", component: <Contratos /> },
  { path: "/rrhh/jornadas", component: <RRHHJornadas /> },

  // Reglas
  { path: "/horarios", component: <Horarios /> },
  { path: "/festivos", component: <Festivos /> },

  // Aprendizaje (Formación) — UI-only. Las rutas estáticas se declaran antes
  // que la dinámica `/formacion/:courseId` para que prevalezcan al hacer match.
  { path: "/formacion", component: <Formacion /> },
  { path: "/formacion/historial", component: <FormacionHistorial /> },
  { path: "/formacion/crear", component: <FormacionCrear /> },
  { path: "/formacion/:courseId", component: <FormacionCurso /> },

  // Soporte IT — UI-only. Las rutas estáticas (crear) se declaran antes que
  // las dinámicas (`/soporte/tickets/:code`) para que prevalezcan al hacer match.
  { path: "/soporte", component: <SoporteDashboard /> },
  { path: "/soporte/tickets", component: <SoporteTickets /> },
  { path: "/soporte/tickets/crear", component: <SoporteCrear /> },
  { path: "/soporte/tickets/:code", component: <SoporteTicketDetalle /> },
  { path: "/soporte/inventario", component: <SoporteInventario /> },
  { path: "/soporte/inventario/:id", component: <SoporteActivo /> },
  { path: "/soporte/recursos", component: <SoporteRecursos /> },
  { path: "/soporte/usuarios/:id", component: <SoporteUsuario /> },
  { path: "/soporte/conocimiento", component: <SoporteConocimiento /> },
  { path: "/soporte/reportes", component: <SoporteReportes /> },

  // Análisis
  { path: "/reportes", component: <Reportes /> },
  { path: "/excesos-jornada", component: <ExcesosJornada /> },

  // Workspace
  { path: "/configuracion", component: <Configuracion /> },
  { path: "/ajustes/modulos", component: <Modulos /> },
  { path: "/ajustes/accesos", component: <Accesos /> },
  { path: "/ajustes/inspeccion-tokens", component: <InspeccionTokens /> },
  { path: "/ajustes/notificaciones", component: <PreferenciasNotificaciones /> },
  { path: "/roles", component: <Roles /> },

  // Sistema
  { path: "/estados", component: <Estados /> },

  // Redirects desde IA antigua / catálogos antiguos
  { path: "/resumen", component: <Navigate to="/dashboard" replace /> },
  { path: "/time-tracking", component: <Navigate to="/jornada" replace /> },
  { path: "/overtime/mis", component: <Navigate to="/mis-solicitudes" replace /> },
  { path: "/rrhh/empleados", component: <Navigate to="/empleados" replace /> },
  {
    path: "/rrhh/empleados/:employeeProfileId",
    component: <RedirectWithParams to="/empleados/:employeeProfileId" />,
  },
  { path: "/rrhh/overtime", component: <Navigate to="/solicitudes" replace /> },
  { path: "/rrhh/catalogos", component: <Navigate to="/horarios" replace /> },
  { path: "/configuracion/catalogos", component: <Navigate to="/horarios" replace /> },

  // Catch-all → dashboard
  { path: "*", component: <Navigate to="/dashboard" replace /> },
];

const publicRoutes = [
  { path: "/", component: <Home /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/verify-registration", component: <VerifyRegistration /> },
  { path: "/register-workspace", component: <RegisterWorkspace /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  // Página de aceptación de invitación: pública porque puede llegarse sin sesión.
  // Si el usuario está logueado, la propia página detecta /me y procesa el accept.
  { path: "/invitations/:token", component: <AcceptInvitation /> },
  // Verificador público de exports firmados (entrada directa, sin login del portal).
  // Útil cuando un externo recibe un PDF/CSV y quiere validarlo sin abrir sesión.
  { path: "/inspeccion/verificar-publico", component: <VerificarExport /> },

  // Portal público de Inspección de Trabajo. Auth: X-Inspection-Token guardado
  // en sessionStorage. PortalLogin pide el token al entrar; las demás pantallas
  // redirigen a /inspeccion si no hay token válido.
  { path: "/inspeccion", component: <PortalLogin /> },
  { path: "/inspeccion/dashboard", component: <PortalDashboard /> },
  { path: "/inspeccion/empleados", component: <PortalEmpleados /> },
  { path: "/inspeccion/jornadas", component: <PortalJornadas /> },
  { path: "/inspeccion/auditoria", component: <PortalAuditoria /> },
  { path: "/inspeccion/verificar", component: <PortalVerificar /> },
];

export { authProtectedRoutes, publicRoutes };
